export default {
  headline: 'Model nie obsługuje azotu',
  text: 'Wybrana receptura wymaga azotu, ale model nie zapewnia odpowiedniej pojemności azotowej. Wybierz inny model lub recepturę',
};
